module.exports = __webpack_public_path__ + "img/mobile-glow.20370019.webp";